
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axios";

// جلب الأقسام
export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async () => {
    const res = await api.get("/categories");
    return res.data.data;
  }
);

// إضافة قسم جديد
export const addCategory = createAsyncThunk(
  "categories/addCategory",
  async (newCategory) => {
    const res = await api.post("/categories", newCategory);
    return res.data.data;
  }
);

// تعديل قسم
export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async ({ id, updatedData }, thunkAPI) => {
    try {
      const response = await api.post(`/categories/${id}`, updatedData); // updatedData is already FormData
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);


// حذف قسم
export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (id) => {
    await api.delete(`/categories/${id}`);
    return id; // نرجع ID للحذف من الحالة
  }
);

const categoriesSlice = createSlice({
  name: "categories",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // جلب
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })

      // إضافة
      .addCase(addCategory.fulfilled, (state, action) => {
        state.items.push(action.payload);
      })

      // تعديل
      .addCase(updateCategory.fulfilled, (state, action) => {
        const index = state.items.findIndex(
          (cat) => cat.id === action.payload.id
        );
        if (index !== -1) {
          state.items[index] = action.payload;
        }
      })

      // حذف
      .addCase(deleteCategory.fulfilled, (state, action) => {
        state.items = state.items.filter((cat) => cat.id !== action.payload);
      });
  },
});

export default categoriesSlice.reducer;
